var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StageAdditionalAgreementForm',{ref:"form",attrs:{"disabled":_vm.disabled,"mode":"automation","value":_vm.valueMutable},on:{"update:value":function($event){_vm.valueMutable=$event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }